import { createContext, useContext, useMemo, useState } from "react";
import {useLocation, useNavigate } from 'react-router-dom'
import React from 'react'
import TokenMiddleware from "./token.middleware";
import Constants from "../tools/constants.tools";


const AuthContext = createContext();

export const useLocalStorage = (defaultValue) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const value = TokenMiddleware.getToken();
      if (value && value !== null && value !== 'null') {
        return value;
      } else {
        TokenMiddleware.setToken(defaultValue);
        return defaultValue;
      }
    } catch (err) {
      return defaultValue;
    }
  });

  const setValue = (newValue) => {
    try {
      TokenMiddleware.setToken(newValue);
    } catch (err) {}
    setStoredValue(newValue);
  };

  return [storedValue, setValue];
};


const useRole = (role) => {
  const [storedValue, setStoredValue] = useState(() => {
    try {
      const value = localStorage.getItem(Constants.ROLE);
      if (value && value !== null && value !== 'null') {
        return value;
      } else {
        localStorage.setItem(Constants.ROLE, role);
        return role;
      }
    } catch (err) {
      return role;
    }
  });

  const setValue = (newValue) => {
    try {
      localStorage.setItem(Constants.ROLE, newValue);
    } catch (err) {}
    setStoredValue(newValue);
  };

  return [storedValue, setValue];
};




export const AuthProvider = ({children}) => {
  const [token, setToken] =  useLocalStorage(null);
  const [role, setRole] =  useRole(null);
  const navigate = useNavigate();
  const location = useLocation()
  const redirectPath = location?.pathname !== '/login' ? location?.pathname : '/dashboard';

  const login = async (token, role) => {
    setToken(token);
    setRole(role)
    navigate(redirectPath, {replace: true});
  }

  const logout = () => {
    setToken(null);
    navigate('/login', {replace: true});
  }

  const value = useMemo(
    () =>({ token, role, login, logout }), 
    [token, role]
  )

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => { return useContext(AuthContext); }
